import i18n from 'shared/helpers/i18n';

import { Validator, ValidationResult, ValidatorOptions } from './Index';

export function regex(
    pattern: RegExp,
    options: ValidatorOptions = new ValidatorOptions()
): Validator {
    return {
        options: options,
        validate: (value: any) => {
            // eslint-disable-next-line
            const hasError = !pattern.test(value);
            return {
                hasError: hasError,
                errorMessage: options.errorMessage
                    ? options.errorMessage
                    : i18n.t('Value has incorrect format'),
            } as ValidationResult;
        },
    };
}
